document.addEventListener('DOMContentLoaded', function () {
  console.log('DOM fully loaded.');

  const buyNowButton = document.getElementById('_rsi-buy-now-button');
  if (!buyNowButton) {
    console.error('Button with ID "_rsi-buy-now-button" not found.');
    return;
  }

  buyNowButton.addEventListener('click', function () {
    console.log('Buy Now button clicked.');

    // Add a delay of 1 second to allow modal to open
    setTimeout(() => {
      console.log('1-second delay completed. Loading Choices.js...');

      // Dynamically load Choices.js CSS
      const choicesCSS = document.createElement('link');
      choicesCSS.rel = 'stylesheet';
      choicesCSS.href = 'https://cdn.jsdelivr.net/npm/choices.js/public/assets/styles/choices.min.css';
      document.head.appendChild(choicesCSS);

      // Dynamically load Choices.js JavaScript
      const choicesScript = document.createElement('script');
      choicesScript.src = 'https://cdn.jsdelivr.net/npm/choices.js/public/assets/scripts/choices.min.js';
      choicesScript.onload = initializeChoices; // Initialize Choices after loading
      document.body.appendChild(choicesScript);
    }, 1000); // 1-second delay
  });

  function initializeChoices() {
    console.log('Choices.js loaded.');

    // Initialize the province dropdown
    initializeDropdown(
      '_rsi-field-province_country_field',
      {
        "AB": "Alba",
        "AG": "Argeș",
        "AR": "Arad",
        "B": "Bucuresti",
        "BC": "Bacău",
        "BH": "Bihor",
        "BN": "Bistrița-Năsăud",
        "BR": "Brăila",
        "BT": "Botoșani",
        "BV": "Brașov",
        "BZ": "Buzău",
        "CJ": "Cluj",
        "CL": "Călărași",
        "CS": "Caraș-Severin",
        "CT": "Constanța",
        "CV": "Covasna",
        "DB": "Dâmbovița",
        "DJ": "Dolj",
        "GJ": "Gorj",
        "GL": "Galați",
        "GR": "Giurgiu",
        "HD": "Hunedoara",
        "HR": "Harghita",
        "IF": "Ilfov",
        "IL": "Ialomița",
        "IS": "Iași",
        "MH": "Mehedinți",
        "MM": "Maramureș",
        "MS": "Mureș",
        "NT": "Neamț",
        "OT": "Olt",
        "PH": "Prahova",
        "SB": "Sibiu",
        "SJ": "Sălaj",
        "SM": "Satu Mare",
        "SV": "Suceava",
        "TL": "Tulcea",
        "TM": "Timiș",
        "TR": "Teleorman",
        "VL": "Vâlcea",
        "VN": "Vrancea",
        "VS": "Vaslui"
      },
      'Cautare Judet...', // Placeholder for dropdown
      'Cautare...' // Placeholder for search input
    );

    // Attach a change event listener to the province dropdown
    const provinceDropdown = document.getElementById('_rsi-field-province_country_field');
    if (provinceDropdown) {
      provinceDropdown.addEventListener('change', () => {
        console.log('Province selected. Reinitializing city dropdown with a delay...');

        // Add a delay to ensure city options are populated
        setTimeout(() => {
          // Reinitialize city dropdown
          initializeCityDropdown();
        }, 1000); // 1-second delay
      });
    }
  }

  function initializeCityDropdown() {
    const cityDropdown = document.getElementById('_rsi-field-city_country_field');

    if (!cityDropdown) {
      console.error('City dropdown not found.');
      return;
    }

    // Clear existing Choices.js instance if already applied
    if (cityDropdown.choices) {
      cityDropdown.choices.destroy();
    }

    // Check if options are present before initializing
    if (cityDropdown.options.length === 0) {
      console.warn('City dropdown is empty. Ensure options are populated before reinitializing.');
      return;
    }

    // Initialize Choices.js for the city dropdown
    initializeDropdown(
      '_rsi-field-city_country_field',
      {}, // No name updates
      'Cautare Localitate...', // Placeholder for dropdown
      'Cautare...' // Placeholder for search input
    );
  }

  /**
   * Initializes a dropdown with Choices.js and updates its option names (if applicable).
   * @param {string} selectId - The ID of the select element.
   * @param {Object} nameMap - A mapping of option values to new display names.
   * @param {string} dropdownPlaceholder - Placeholder text for the dropdown.
   * @param {string} searchPlaceholder - Placeholder text for the search input.
   * @param {boolean} alwaysVisible - If true, all options will always be displayed (list box style).
   */
  function initializeDropdown(selectId, nameMap, dropdownPlaceholder, searchPlaceholder, alwaysVisible = false) {
    const selectElement = document.getElementById(selectId);
    if (!selectElement) {
      console.error(`Select element with ID "${selectId}" not found.`);
      return;
    }

    // Update option names if a mapping is provided
    if (Object.keys(nameMap).length > 0) {
      Array.from(selectElement.options).forEach(option => {
        if (nameMap[option.value]) {
          option.text = nameMap[option.value];
        }
      });
      console.log(`Updated option names for "${selectId}".`);
    }

    // Initialize Choices.js for the select element
    const choicesConfig = {
      searchEnabled: true,                 // Enables the search bar
      itemSelectText: '',                  // Removes the "Press to select" text
      placeholder: true,                   // Enables placeholder for the dropdown
      placeholderValue: dropdownPlaceholder, // Placeholder for the dropdown
    };

    // If alwaysVisible is true, configure as a list box
    if (alwaysVisible) {
      choicesConfig.renderChoiceLimit = -1; // No limit on visible items
      choicesConfig.shouldSort = false;    // Preserve original order
    }

    const choicesInstance = new Choices(selectElement, choicesConfig);
    selectElement.choices = choicesInstance; // Attach instance for potential cleanup

    // Add placeholder to the search input field
    const searchInput = selectElement.parentElement.querySelector('.choices__input--cloned');
    if (searchInput) {
      searchInput.setAttribute('placeholder', searchPlaceholder);
    }

    console.log(`Choices.js initialized for "${selectId}".`);
  }
});
